
import { hydrateCSRTemplate } from '@fiverr-private/layout_lib/CSRTemplate';
import { handleCSRError } from '@fiverr-private/layout_lib/CSRTemplate';
import { loader } from '/home/circleci/app/packages/layout-footer-component/src/entries/FooterWithoutSelectors';
const getRootElement = () => typeof document !== 'undefined' && document.querySelector('#Footer');
const lazyImport = () => import(
    /* webpackChunkName: "FooterWithoutSelectorsLazyComponent" */
    /* webpackExports: ["default"] */
    '/home/circleci/app/packages/layout-footer-component/src/entries/FooterWithoutSelectors?version=1'
);
const hydrateComponent = async () => {
    try {
        const { default: Component } = await lazyImport();
        const props = window.initialData['Footer'];
        const root = getRootElement();
        if (root) {
            hydrateCSRTemplate(Component, props, root, 'Footer', 'FooterWithoutSelectors');
        }
    } catch(error) {
        handleCSRError(error, "Footer", "FooterWithoutSelectors");
    }
};
const main = async () => {
    try {
        const root = getRootElement();
        if (root) {
            await loader(hydrateComponent, root);
        }
    } catch(error) {
        handleCSRError(error, "Footer", "FooterWithoutSelectors");
    }
};
main();
export default main;
